import React from 'react'
import { FieldRenderProps } from 'react-final-form'
import Icon from '../../Icon'
import { FieldIcon, Input as StyledInput } from './styles'
import { Html, InputData } from './type'

interface Props extends FieldRenderProps<string, HTMLInputElement> {
  id: string
  data: InputData
  html: Html
}


const Input: React.FC<Props> = ({
  id,
  input,
  data,
  html = {
    maxLength: 255,
  },
}) => {
  return (
    <>
      {data.icon && (
        <FieldIcon>
          <Icon
            name={data.icon}
          />
        </FieldIcon>
      )}

      <StyledInput
        id={id}
        {...input}
        {...html}
      />
    </>
  )
}

export default Input
